import React, { Fragment } from "react";
import { pathOr } from "ramda";
import styled from "styled-components";
import { Panel } from "@pga/pga-component-library";
import Title from "./common/Title";
import JobApplySection from "./JobApplySection";
import JobDetailInfoSection from "./JobDetailInfoSection";
import {
  Content,
  ApplyForJob,
  PageData,
  DeadlineAlert,
  DEADLINE_MESSAGE,
} from "./DesktopView";
import JobDetailSideBar from "./JobDetailSideBar";
import JobDetailStats from "./JobDetailStats";
import {
  jobAdditionalData,
  isInternshipApplicantGroup,
  isValidDeadline,
  getFacilityUrl,
  isValidPostingStage,
} from "./utils";
import ShowApplyButton from "./ShowApplyButton";
import ErrorOverlay from "./ErrorOverlay";

const StyledPanel = styled(Panel)`
  box-shadow: none;
  padding-top: 0px;
  margin: 0px auto;
  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
`;

const Header = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  background-color: rgb(244, 247, 248);
`;

export default ({ data }) => {
  const isValidDeadlineDate = isValidDeadline(data.job);
  const isValidPostingStageForApplication = isValidPostingStage(data.job);
  return (
    <Fragment>
      {!isValidDeadlineDate ? (
        <DeadlineAlert color="danger">{DEADLINE_MESSAGE}</DeadlineAlert>
      ) : null}
      <Header>
        <Title>
          {isInternshipApplicantGroup(data) && "Internship: "}
          {pathOr("N/A", ["job", "jobTitle"], data)}
        </Title>
        <ShowApplyButton
          data={data}
          facilityUrl={getFacilityUrl(data)}
          isValidDeadline={isValidDeadlineDate}
          isValidPostingStage={isValidPostingStageForApplication}
        />
      </Header>
      <StyledPanel>
        <ContentWrapper>
          <Content>
            <JobDetailStats job={data.job} />
            <JobDetailSideBar {...{ data }} />
            <PageData>
              {jobAdditionalData(data.job).map(({ title, children }) => (
                <JobDetailInfoSection
                  title={title}
                  key={title}
                  children={children}
                />
              ))}
            </PageData>
            <ApplyForJob>
              {!isValidDeadlineDate ? (
                <ErrorOverlay message={DEADLINE_MESSAGE} />
              ) : null}
              <JobApplySection data={data} facilityUrl={getFacilityUrl(data)} />
            </ApplyForJob>
          </Content>
        </ContentWrapper>
      </StyledPanel>
    </Fragment>
  );
};
